// extracted by mini-css-extract-plugin
module.exports = {"primary-blue":"#428bca","primary-blue-interaction":"#3c71a1","primary-blue-disabed":"#a4c7e4","primaryButton":"PrimaryButton_primaryButton__1pelK"};